// Components
import WebsitePreview from '../WebsitePreview';
import RegistryPreview from '../WebsitePreview/RegistryPreview';
import WeddingPartyMembers from '../entities/WeddingPartyMembers';
import Faqs from '../entities/Faqs';
import Pois from '../entities/Pois';
import Travel from '../entities/Travel/Travel';
import RegistryV2 from '../entities/RegistryV2';
import RegistryContainer from '../entities/RegistryContainer';
import Photos from '../entities/Photos';
import HomepageSections from '../entities/HomepageSections';
import Events from '../entities/EventsV2';
import RsvpContainer from '../entities/Rsvp/RsvpContainer';
import featureFlags from '../../../../util/featureFlags';

const isWebToReg = featureFlags.get('webToReg');

// eslint-disable-next-line import/prefer-default-export
export const EDIT_PAGE_COMPONENTS = {
  WEDDING_PARTY: {
    page: WeddingPartyMembers,
    preview: WebsitePreview,
  },
  POI: {
    page: Pois,
    preview: WebsitePreview,
  },
  FAQ: {
    page: Faqs,
    preview: WebsitePreview,
  },
  TRAVEL: {
    page: Travel,
    preview: WebsitePreview,
  },
  REGISTRY: {
    page: isWebToReg ? RegistryContainer : RegistryV2,
    preview: isWebToReg ? undefined : RegistryPreview,
  },
  PHOTO: {
    page: Photos,
    preview: WebsitePreview,
  },
  HOME: {
    page: HomepageSections,
    preview: WebsitePreview,
  },
  EVENT: {
    page: Events,
    preview: WebsitePreview,
  },
  RSVP: {
    page: RsvpContainer,
    preview: undefined,
  },
};

export const WEBSITE_PAGE_TYPES = {
  WEDDING_PARTY: 'WEDDING_PARTY',
  POI: 'POI',
  FAQ: 'FAQ',
  TRAVEL: 'TRAVEL',
  REGISTRY: 'REGISTRY',
  PHOTO: 'PHOTO',
  HOME: 'HOME',
  EVENT: 'EVENT',
  RSVP: 'RSVP',
};



// WEBPACK FOOTER //
// ./src/components/manage/website/util/constants.js